/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCompaniesNearMeRequest } from '../../models/get-companies-near-me-request';
import { PostCategoryResponse } from '../../models/post-category-response';

export interface GetPostCategoriesByCompanySearchFilters$Params {
      body: GetCompaniesNearMeRequest
}

export function getPostCategoriesByCompanySearchFilters(http: HttpClient, rootUrl: string, params: GetPostCategoriesByCompanySearchFilters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PostCategoryResponse>>> {
  const rb = new RequestBuilder(rootUrl, getPostCategoriesByCompanySearchFilters.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PostCategoryResponse>>;
    })
  );
}

getPostCategoriesByCompanySearchFilters.PATH = '/api/post-categories-by-company-search-filters';
